import { Check, X, Backpack } from 'lucide-react';

interface ExcursionInclusionsProps {
  inclus?: string[];
  nonInclus?: string[];
  equipement?: string[];
}

export const ExcursionInclusions = ({ inclus, nonInclus, equipement }: ExcursionInclusionsProps) => {
  const hasContent = (inclus && inclus.length > 0) || (nonInclus && nonInclus.length > 0) || (equipement && equipement.length > 0);
  
  if (!hasContent) return null;

  return (
    <div className="grid md:grid-cols-2 gap-8">
      {/* Ce qui est inclus */}
      {inclus && inclus.length > 0 && (
        <section>
          <h3 className="text-2xl font-playfair font-bold mb-4 flex items-center gap-2">
            <div className="w-2 h-8 bg-accent rounded" />
            Ce qui est inclus
          </h3>
          <ul className="space-y-3">
            {inclus.map((item, index) => (
              <li key={index} className="flex items-start gap-3">
                <div className="w-5 h-5 rounded-full bg-accent/20 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <Check className="w-3 h-3 text-accent" />
                </div>
                <span className="text-muted-foreground leading-relaxed">{item}</span>
              </li>
            ))}
          </ul>
        </section>
      )}

      {/* Ce qui n'est pas inclus */}
      {nonInclus && nonInclus.length > 0 && (
        <section>
          <h3 className="text-2xl font-playfair font-bold mb-4 flex items-center gap-2">
            <div className="w-2 h-8 bg-destructive rounded" />
            Ce qui n'est pas inclus
          </h3>
          <ul className="space-y-3">
            {nonInclus.map((item, index) => (
              <li key={index} className="flex items-start gap-3">
                <div className="w-5 h-5 rounded-full bg-destructive/20 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <X className="w-3 h-3 text-destructive" />
                </div>
                <span className="text-muted-foreground leading-relaxed">{item}</span>
              </li>
            ))}
          </ul>
        </section>
      )}

      {/* Équipement recommandé */}
      {equipement && equipement.length > 0 && (
        <section className="md:col-span-2">
          <h3 className="text-2xl font-playfair font-bold mb-4 flex items-center gap-2">
            <Backpack className="w-6 h-6 text-primary" />
            Équipement recommandé
          </h3>
          <div className="grid sm:grid-cols-2 gap-3">
            {equipement.map((item, index) => (
              <div key={index} className="flex items-center gap-3 bg-muted/50 rounded-lg p-3">
                <div className="w-2 h-2 rounded-full bg-primary flex-shrink-0" />
                <span className="text-sm leading-relaxed">{item}</span>
              </div>
            ))}
          </div>
        </section>
      )}
    </div>
  );
};
